import client from 'api/client';
import { AxiosResponse } from 'axios';

export function getEventLogs(title: string): Promise<AxiosResponse> {
    return client.get<{ finished_assessment: string[] }>(`event_log/${title}`);
}
